/**
 * In-place Editor classes defined here.
 */
/** @hidden */
export const ROOT = 'e-inplaceeditor';
/** @hidden */
export const ROOT_TIP = 'e-inplaceeditor-tip';
/** @hidden */
export const VALUE_WRAPPER = 'e-editable-value-wrapper';
/** @hidden */
export const VALUE = 'e-editable-value';
/** @hidden */
export const OVERLAY_ICON = 'e-editable-overlay-icon';
/** @hidden */
export const TIP_TITLE = 'e-editable-tip-title';
/** @hidden */
export const TITLE = 'e-editable-title';
/** @hidden */
export const INLINE = 'e-editable-inline';
/** @hidden */
export const POPUP = 'e-editable-popup';
/** @hidden */
export const WRAPPER = 'e-editable-wrapper';
/** @hidden */
export const LOADING = 'e-editable-loading';
/** @hidden */
export const FORM = 'e-editable-form';
/** @hidden */
export const CTRL_GROUP = 'e-component-group';
/** @hidden */
export const INPUT = 'e-editable-component';
/** @hidden */
export const BUTTONS = 'e-editable-action-buttons';
/** @hidden */
export const EDITABLE_ERROR = 'e-editable-error';
/** @hidden */
export const ELEMENTS = 'e-editable-elements';
/** @hidden */
export const OPEN = 'e-editable-open';
/** @hidden */
export const BTN_SAVE = 'e-btn-save';
/** @hidden */
export const BTN_CANCEL = 'e-btn-cancel';
/** @hidden */
export const RTE_SPIN_WRAP = 'e-rte-spin-wrap';
/** @hidden */
export const CTRL_OVERLAY = 'e-control-overlay';
/** @hidden */
export const DISABLE = 'e-disable';
/** @hidden */
export const ICONS = 'e-icons';
/** @hidden */
export const PRIMARY = 'e-primary';
/** @hidden */
export const SHOW = 'e-show';
/** @hidden */
export const HIDE = 'e-hide';
/** @hidden */
export const RTL = 'e-rtl';
/** @hidden */
export const ERROR = 'e-error';
/** @hidden */
export const LOAD = 'e-loading';
